import { createMotionComponent } from "../../../motion";
export function createMinimalMotionComponent(Component, options) {
    return createMotionComponent(Component, options);
}
//# sourceMappingURL=create.js.map